import PaginationRequest from '@/common/pagination/entities/pagination-request'

export default class FoldersRequest {
  public text = ''
  public paging: PaginationRequest = new PaginationRequest()
}
